import { render, staticRenderFns } from "./ux-upload.vue?vue&type=template&id=2047ca9e&"
import script from "./ux-upload.vue?vue&type=script&lang=js&"
export * from "./ux-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports